import axios from 'axios'

export const fetchRegions = () => {
  return axios.get('/init')
}

export const businessListUrlGenerator = ({
  regionId,
  serviceId,
  isGeolocationUsed
}) => {
  let businessListUrl = `/businesses?region_id=${regionId}`

  serviceId && (businessListUrl += `&service_id=${serviceId}`)
  isGeolocationUsed && (businessListUrl += `&isGeolocationUsed=true`)

  return businessListUrl
}

export const fetchBusinessList = ({
  regionId,
  serviceId,
  longitude,
  latitude
}) => {
  return axios
    .get('/businesses', {
      params: {
        service_id: serviceId,
        region_id: regionId,
        lat: latitude,
        lng: longitude
      }
    })
    .then((res) => res.data)
}

export const fetchRegionsv2 = () => {
  return axios.get('/init').then((res) => res?.data?.regions)
}
